import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/common/Button/Button'


const AppointmentButton = ({
  disabled,
  onClickHandler
}) =>
  <Button
    data-at-continue-button
    disabled={ disabled }
    full="mobile"
    onClick={ onClickHandler }>
    Continue
  </Button>

AppointmentButton.propTypes = {
  disabled: PropTypes.bool,
  onClickHandler: PropTypes.func
}

export default AppointmentButton
